import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const PrivateRoute = ({
  component: Component,
  componentProps,
  forwardedRef,
  ...rest
}: any) => (
  <Route
    {...rest}
    component={(props: any) =>
      cookies.get('username') ? (
        <Component ref={forwardedRef} {...componentProps} {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      )
    }
  />
);
